import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import CYWD20220126 from '@/views/20220126CYWD';
import AYJP20220128 from '@/views/20220128AYJP';
import XNHK20220130 from '@/views/20220130XNHK';
import XFWQ20220218 from '@/views/20220218XFWQ';
import QGLH20220301 from '@/views/20220301QGLH';
import LHYWD20220301 from '@/views/20220301LHYWD';
import GKDBM20220309 from '@/views/20220309GKDBM';
import TDDKT20220309 from '@/views/20220309TDDKT';
import FSDS20220325 from '@/views/20220325FSDS';
import FB20220330 from '@/views/20220330FB';
import KJRW20220330 from '@/views/20220330KJRW';
import SYBS20220401 from '@/views/20220401SYBS';
import JJRW20220408 from '@/views/20220408JJRW';
import CBHXJ20220408 from '@/views/20220408CBHXJ';
import GKZSWD20220411 from '@/views/20220411GKZSWD';
import NLXQP20220414 from '@/views/20220414NLXQP';
import BMB20220420 from '@/views/20220420BMB';
import CQGJWH20220420 from '@/views/20220420CQGJWH';
import KJCX20220422 from '@/views/20220422KJCX';
import JKLNR20220429 from '@/views/20220429JKLNR';
import IPM20220511 from '@/views/20220511IPM';
import CMLY20220523 from '@/views/20220523CMLY';
import SHLJ20220523 from '@/views/20220523SHLJ';
import GYGG20220525 from '@/views/20220525GYGG';
import TYSY20220527 from '@/views/20220527TYSY';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 春运云问答
    CYWD20220126,
    // 冬奥会奖牌榜
    AYJP20220128,
    // 	2022新年贺卡
    XNHK20220130,
    // 上游新闻315消费维权线索征集平台
    XFWQ20220218,
    // 中国，行稳致远
    QGLH20220301,
    // 两会云问答
    LHYWD20220301,
    // 2022中高考大帮忙
    GKDBM20220309,
    // 开启·梦想
    TDDKT20220309,
    // 2021西部怡美新女性风尚大赛
    FSDS20220325,
    // 市乡村振兴局，永远的丰碑
    FB20220330,
    // 2021年重庆市制造业十大影响年度人物评选
    KJRW20220330,
    // 重庆市全面健身摄影比赛
    SYBS20220401,
    // 2021年度经济人物评选
    JJRW20220408,
    // 重报换新家
    CBHXJ20220408,
    // 高招生问答
    GKZSWD20220411,
    // 新征程上努力向前跑
    NLXQP20220414,
    // 报名表
    BMB20220420,
    // 重庆国际文化旅游专业博览会
    CQGJWH20220420,
    // 2022十大重庆科技创新年度人物评选
    KJCX20220422,
    // 2022重庆健康老人评选
    JKLNR20220429,
    // 中国石化万科内购会
    IPM20220511,
    // 重庆艺术大市场•开放的六月2022四川美术学院云端艺术游展览
    CMLY20220523,
    // 《重庆市生活垃圾管理条例》专题知识竞赛
    SHLJ20220523,
    // 	2022年重庆市公益广告大赛
    GYGG20220525,
    // 2022渝北区首届体育摄影比赛
    TYSY20220527,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },

  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    const res: any = await getUnionId({ code });
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
